import { all, put, takeEvery, call } from "redux-saga/effects";
import { PERMISSIONS_ACTIONS, PERMISSIONS_TYPES } from "./actions";
import { getPermissions } from "../../services/api/permissions";

export function* watchPermissionsActions() {
  yield all([takeEvery(PERMISSIONS_TYPES.LOAD_ALL_REQUEST, loadPermissions)]);
}

function* loadPermissions(action) {
  const { params } = action.payload;
  try {
    const permissions = yield call(getPermissions, params);
    yield put(PERMISSIONS_ACTIONS.loadAllSuccess(permissions));
  } catch (e) {
    yield put(PERMISSIONS_ACTIONS.loadAllFailure(e));
  }
}
